import styled from '@emotion/styled'
import { TextField } from '@mui/material'
// import variables from '../../styles/Global.module.scss'

export const CustomTextField = styled(TextField)({
  '& input.Mui-disabled': {
    // color: `#38383880`,
  },
  '& label.Mui-focused': {
    // color: `#38383880`,
  },
  '& .MuiOutlinedInput-root': {
    backgroundColor: '#ffff',
    borderRadius: '5px',
    input: {
      padding: '12.5px 14px',
    },
    '& ::placeholder': {
      color: `#38383880`,
    },
  },
  '& .MuiOutlinedInput-root.Mui-focused': {
    backgroundColor: '#ffff',
    border: '0px',
    boxSizing: 'border-box',
    // color: `#38383880`,
  },
  '& .MuiOutlinedInput-root:hover': {
    backgroundColor: '#ffff',
    boxSizing: 'border-box',
  },
  '& .MuiOutlinedInput-root.Mui-disabled': {
    border: `0px`,
    boxSizing: 'border-box',
  },
  // '& .css-1d3z3hw-MuiOutlinedInput-notchedOutline': {
  //   borderColor: `${variables.primaryColor}`,
  // },
})
